



































































import { Component, Vue } from 'vue-property-decorator'
import { BIconCalendar, BInputGroupAppend, BInputGroup, BForm, BFormRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BIconSearch, BIconArrowCounterclockwise, BFormSelectOption } from 'bootstrap-vue';
import PerformedWorkFilterOptions from '@/types/PerformedWorkFilterOptions'
import EntityReference from '@/types/EntityReference';
import DateTimePicker from '@/components/DateTimePicker.vue';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';
import DateTime from '../types/DateTime';

@Component({
    components: {
        'b-form': BForm,
        'b-form-row': BFormRow,
        'b-col': BCol,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-search': BIconSearch,
        'b-icon-arrow-counterclockwise': BIconArrowCounterclockwise,
        'b-input-group': BInputGroup,
        'date-picker': DateTimePicker,
        'b-input-group-append': BInputGroupAppend,
        'b-icon-calendar': BIconCalendar,
    }
})
export default class PerformedWorkFilter extends Vue {
    users: EntityReference[] = [];
    projects: ProjectFilterItem[] = [];
    apiAccessToken = this.$store.state.apiAccessToken;
    startDate: number | string | Date | moment.Moment | moment.MomentInputObject | null = null;
    endDate: number | string | Date | moment.Moment | moment.MomentInputObject | null = null;

    filter: PerformedWorkFilterOptions = {
        userId: null,
        projectId: null,
        startDate: null,
        endDate: null
    }

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadUsers();
        this.loadProjects();
    }

    filterList(resetFilter: boolean) {
        if (resetFilter) {
            this.filter.userId = null;
            this.filter.projectId = null;
            this.filter.startDate = null;
            this.filter.endDate = null;
        }
        this.$emit('filter-list', this.filter);
    }

    async loadUsers() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `userslookup/performedworkfilter`,
                method: 'GET'
            });

            this.users = response.data.records ?? [];

            if (this.users.length == 1) {
                this.filter.userId = this.users[0].id;
            }
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    async loadProjects() {
        try {
            const response = await AxiosService.request<ProjectList>({
                url: `projectslookup`,
                method: 'GET'
            });

            this.projects = response.data.records ?? [];
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    onChangeStartDate(e: moment.Moment | null) {
        if (!e) {
            this.filter.startDate = null;
            return;
        }
        const localStartDate = DateTime.toLocal(e, DateTime.formats.date)?.startOf('day').utcOffset(0, true);
        this.filter.startDate = DateTime.toUtc(localStartDate, DateTime.formats.date) as moment.Moment;
    }

    onChangeEndDate(e: moment.Moment | null) {
        if (!e) {
            this.filter.endDate = null;
            return;
        }
        const localEndDate = DateTime.toLocal(e, DateTime.formats.date)?.startOf('day').utcOffset(0, true);
        this.filter.endDate = DateTime.toUtc(localEndDate, DateTime.formats.date) as moment.Moment;
    }
}

interface EntityList {
    records: EntityReference[];
}

interface ProjectList {
    records: ProjectFilterItem[];
}

interface ProjectFilterItem {
    id: string;
    name: string;
    projectManagerId: string;
}

